<pdf-shy-button
  primaryToolbarId="primaryMoveDownButton"
  secondaryMenuId="secondaryMoveDownButton"
  [cssClass]="showMoveDownButton | responsiveCSSClass: 'hiddenSmallView'"
  title="Move Page Down"
  l10nLabel="pdfjs-editor-movePageDown-button-label"
  [action]="movePageDown"
  image="<svg viewBox='0 0 24 24' height='20px' width='24px' aria-hidden='true'><path d='M14 2l6 6v7a2 2 0 0 1-2 2v-3H6v3a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8m4 12v-5h-5v-5H6v10h12z' fill='currentColor'></path><path d='M6 16h12' stroke-dasharray='3,2' stroke-width='2' stroke='currentColor' fill='none'></path><path d='M12 23l-4-4h8l-4 4z' fill='currentColor'></path></svg>"
  [order]="450"
>
</pdf-shy-button>
